/** @type {(width: number) => number} */
export const getLineLength = (width) =>
	// prettier-ignore
	width <  560 ? 10 :
	width <  670 ? 20 :
	width <  770 ? 30 :
	width <  870 ? 40 :
	width <  970 ? 50 :
	width < 1070 ? 60 :
	width < 1170 ? 70 :
	80;
